export default __webpack_public_path__ + "static/media/icon_hallinto_summary.09f89688.svg";